import { db } from "@db";
import { toast } from "sonner";

export type StorageQuotaStatus = {
  usage: number;
  limit: number;
  isOverQuota: boolean;
};

export async function checkStorageQuota(): Promise<StorageQuotaStatus> {
  const [estimate, settings] = await Promise.all([
    navigator.storage.estimate(),
    db.settings.get("settings"),
  ]);

  const usage = estimate.usage ?? 0;
  const limit = settings?.storageLimit ?? 0;

  return { usage, limit, isOverQuota: limit > 0 && usage > limit };
}

export const OVER_QUOTA_MESSAGE =
  "Storage limit reached. Free up space or increase your limit in Settings.";

export async function guardStorageQuota(): Promise<boolean> {
  const { isOverQuota } = await checkStorageQuota();

  if (isOverQuota) {
    toast.error(OVER_QUOTA_MESSAGE);
  }

  return isOverQuota;
}
